/*
Copyright MITSUBISHI Elec.
*/

/**
Chart.jsをベースとしたBlenderのグラフ描画クラスとプラグイン。

@module BlenderChart
@main BlenderChart
**/

//---------------------------------------
// BlenderChart用のデフォルト設定。
//---------------------------------------
(function() {
	'use strict';

	Chart.defaults._set('global', {

		// アニメーション設定
		animation: {
			duration: 400
		},

		// 余白設定
		layout: {
			padding: {
				left: 8,
				right: 24,
				top: 24,
				bottom: 8
			}
		},

		// リサイズ時にアスペクト比を維持　無効
		maintainAspectRatio: false,

		// フォント
		defaultFontFamily: "'メイリオ', Meiryo, '游ゴシック体', YuGothic, '游ゴシック', 'Yu Gothic', sans-serif",

		// Chart上のイベント設定
		// touch関連のイベントを除去、mouseイベントを整理
		events: [ 'mousemove', 'mousedown', 'mouseup', 'mouseout' ],

		// 背景色
		backgroundColor: '#fff'

	});

})();

//---------------------------------------
// BlenderChart　軸拡張
//---------------------------------------

(function() {
	'use strict';

	var helpers = Chart.helpers;

	/**
	 * BlenderChart Category2軸
	 * 最大／最小値をデータ配列のインデックスで管理する軸クラス。
	 *
	 * @class BlenderDateSetScale
	 * @module BlenderChart
	 * @extends [Chart.Scale]
	 */
	var BlenderDateSetScale = Chart.Scale.extend({

		/**
		 * ラベル配列を取得する。
		 *
		 * @method _getLabels
		 * @private
		 * @return {array} ラベル配列
		 */
		_getLabels: function() {
			var me = this;
			var data = me.chart.data;
			return me.options.labels || (me.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},

		/**
		 * データの表示範囲を決定し、this.min および this.max に設定する。
		 *
		 * @method determineDataLimits
		 */
		determineDataLimits: function() {
			var me = this;
			var labelIndexMax = Math.max(0, me._getLabels().length - 1);

			var opts = me.options.ticks;
			var minIndex = parseInt(opts.min, 10);
			var maxIndex = parseInt(opts.max, 10);

			if (isNaN(minIndex)) {
				minIndex = 0;
			} else {
				minIndex = Math.max(0, Math.min(minIndex, labelIndexMax));
			}

			if (isNaN(maxIndex)) {
				maxIndex = labelIndexMax;
			} else {
				maxIndex = Math.max(0, Math.min(maxIndex, labelIndexMax));
			}

			me.min = minIndex;
			me.max = maxIndex;
		},

		/**
		 * 軸の目盛りを生成し、this.ticks に設定する。
		 *
		 * @method buildTicks
		 */
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var len = labels.length;

			if (len && (me.min !== 0 || me.max !== (len - 1))) {
				labels = labels.slice(me.min, me.max + 1);
			}
			me.ticks = labels;
		},

		/**
		 * 引数のインデックスが示す場所に表示しているデータを取得する。
		 *
		 * @method getLabelForIndex
		 * @param index {number} データ配列のインデックス
		 * @param datasetIndex {number} 系列のインデックス
		 * @return {number|string} 表示データ
		 */
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;

			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
			return me._getLabels()[index];
		},

		/**
		 * 引数の値またデータ配列のインデックスから、座標を取得する。
		 * ※ 座標(0, 0)はCanvasの左上隅とする。
		 *
		 * @method getPixelForValue
		 * @param value {number|object} 座標を取得する値
		 * @param index {number} 座標を取得する値のデータ配列インデックス
		 * @param datasetIndex {number} 系列のインデックス
		 * @return {number} 値の座標（水平軸はX座標、垂直軸はY座標）
		 */
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var offset = me.options.offset;
			var offsetAmt = Math.max((me.max + 1 - me.min - (offset ? 0 : 1)), 1);
			var isHorz = me.isHorizontal();

			if (!helpers.isNullOrUndef(index) && !helpers.isNullOrUndef(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}

			// valueがオブジェクトの場合、データ配列のインデックスでは座標を取得できない。
			// よって、値から座標を算出する。
			var valueCategory;
			if (!helpers.isNullOrUndef(value)) {
				valueCategory = isHorz ? value.x : value.y;
			}
			// 引数のインデックス指定がない、あるいは座標算出に使えない場合、
			// 軸ラベル配列のインデックスを使用する。
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				value = helpers.valueOrDefault(valueCategory, value);
				var idx = me._getLabels().indexOf(value);
				index = (idx !== -1) ? idx : isNaN(index) ? value : index;
			}

			value = (isHorz ? me.width : me.height) / offsetAmt;

			var valueOffset = value * (index - me.min);
			if (offset) {
				valueOffset += (value / 2);
			}
			return (isHorz ? me.left : me.top) + Math.round(valueOffset);
		},

		/**
		 * 目盛りの座標を取得する。
		 * ※ 座標(0, 0)はCanvasの左上隅とする。
		 *
		 * @method getPixelForTick
		 * @param index {number} 目盛りのインデックス
		 * @return {number} 目盛りの座標（水平軸はX座標、垂直軸はY座標）、インデックスが範囲外の場合はnull
		 */
		getPixelForTick: function(index) {
			var t = this.ticks;
			var ret = null;

			if (0 <= index && index < t.length) {
				ret = this.getPixelForValue(t[index], (index + this.min));
			}
			return ret;
		},

		/**
		 * 引数の座標からグラフ値を取得する。
		 * ※ 座標(0, 0)はCanvasの左上隅とする。
		 *
		 * @method getValueForPixel
		 * @param pixel {number} 水平軸ならばX座標、垂直軸ならばY座標
		 * @return {number} グラフの値
		 */
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var offsetAmt = Math.max((me.getTicks().length - (offset ? 0 : 1)), 1);
			var isHorz = me.isHorizontal();
			var valueDimension = (isHorz ? me.width : me.height) / offsetAmt;

			pixel -= (isHorz ? me.left : me.top);

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			var value;
			if (pixel > 0) {
				value = Math.round(pixel / valueDimension);
			} else {
				value = 0;
			}

			return value + me.min;
		},

		/**
		 * 最小の値が存在する座標を返す。
		 * ※ 座標(0, 0)はCanvasの左上隅とする。
		 *
		 * @method getBasePixel
		 * @return {number} 最小の値が存在する座標（水平軸はX座標、垂直軸はY座標）
		 */
		getBasePixel: function() {
			return this.bottom;
		}

	});

	// スケールクラスのコンストラクタを登録。
	Chart.scaleService.registerScaleType('category2', BlenderDateSetScale, {
		position: 'bottom'
	});

})();


//-----------------------------------------------
// BlenderChartのPlugin機能拡張
//-----------------------------------------------

(function() {
	'use strict';

	// ChartのHelper
	var helpers = Chart.helpers;
	// Chartのプラグイン管理
	var plugins = Chart.plugins;
	// descriptors関数オリジナル
	var funcDescriptors = plugins.descriptors;

	// デフォルト優先度
	var DEFAULT_PRIORITY = 50;

	/**
	 * 指定されたChartの有効なプラグインの記述子の配列を返す。
	 * プラグインは、priorityフィールド値の降順にソートされ、配列の先頭から実行される。
	 *
	 * 有効なpriorityフィールド値が存在しない場合のデフォルト値は50とする。
	 *
	 * @private
	 * @return {array} プラグインと対応するoptionsを格納したオブジェクト配列。
	 *                  [{ plugin, options }, { plugin, options }, ...]
	 */
	plugins.descriptors = function(chart) {
		var me = this;
		var cache = chart._plugins;

		// descriptorsの再生成によりソートが必要になる場合はtrue
		var needsSort = (!cache || cache.id !== me._cacheId);
		// descriptorsを生成
		var descriptors = funcDescriptors.call(me, chart);

		if (needsSort) {
			sortDescriptorsByPriority(descriptors);
		}
		return descriptors;
	};

	/**
	 * 実行優先度による比較関数。
	 *
	 * @private
	 * @param a {object} 比較を行うオブジェクト1
	 * @param b {object} 比較を行うオブジェクト2
	 * @return 2つのオブジェクトの優先度を比較し、配列の順序を決定するための数値。
	 *            ・引数aが引数bより高い場合は-1。
	 *            ・引数aと引数bが等価の場合は0。
	 *            ・引数aが引数bより低い場合は1。
	 */
	function compareByPriority(a, b) {
		return compareNumber(b._tmpPriority, a._tmpPriority)
				|| compareNumber(a._tmpIndex, b._tmpIndex);
	};

	/**
	 * 数値の比較を行います。
	 *
	 * @private
	 * @param a {number} 比較を行う数値1
	 * @param b {number} 比較を行う数値2
	 * @return {number} aとbが同値の場合は0、aがbより小さい場合は-1、aがbより大きい場合は1
	 */
	function compareNumber(a, b) {
		return (a < b) ? -1 : ((a === b) ? 0 : 1);
	}

	/**
	 * プラグイン記述子配列をプラグインのpriorityフィールド値の降順にソートする。
	 * priorityフィールド値が同一の場合、元の順序を維持する。
	 *
	 * @private
	 * @param array {Array} ソート対象の配列
	 * @return ソートした結果
	 */
	function sortDescriptorsByPriority(descriptors) {
		var len = descriptors.length;
		var i, descriptor, priority;

		// ソートに必要な一時パラメータを設定。
		for (i = 0; i < len; i++) {
			descriptor = descriptors[i];
			priority = descriptor.plugin.priority;

			// 有効なpriorityが存在しない場合、デフォルト値を設定。
			if (!helpers.isNumber(priority)) {
				priority = DEFAULT_PRIORITY;
			}
			descriptor._tmpPriority = priority;

			// 優先度が同一の場合、順序を維持するために配列のindexを保持
			descriptor._tmpIndex = i;
		}

		// ソート実行
		descriptors.sort(compareByPriority);

		// ソート完了後、一時フィールドを除去
		for (i = 0; i < len; i++) {
			descriptor = descriptors[i];
			delete descriptor._tmpPriority;
			delete descriptor._tmpIndex;
		}
	};

	/**
	 * Plugin extension hooks.
	 * @interface IBlenderPlugin
	 * @extends [IPlugin]
	 */
	/**
	 * @method IBlenderPlugin#beforeOverlapAreaShow
	 * @desc $overlapArea を表示する前に呼び出されます。
	 * いずれかのプラグインが false を返す場合、他の showOverlapArea がトリガされるまで、
	 * $overlapAreaの表示はキャンセルされます。
	 * @param chart {object} BlenderChartインスタンス
	 * @param options {object} プラグインオプション
	 * @return {boolean} falseの場合、$overlapArea表示および、以降のbeforeOverlapAreaShow、
	 * afterOverlapAreaShowをフックするプラグインの実行をキャンセルします。
	 */
	/**
	 * @method IBlenderPlugin#afterOverlapAreaShow
	 * @desc $overlapArea を表示した後に呼び出されます。
	 * $overlapAreaの表示がキャンセルされた場合、このフックは呼び出されません。
	 * @param chart {object} BlenderChartインスタンス
	 * @param options {object} プラグインオプション
	 * @return {boolean} falseの場合、$overlapArea表示および、以降のbeforeOverlapAreaShow、
	 * afterOverlapAreaShowをフックするプラグインの実行をキャンセルします。
	 */

})();


//-----------------------------------------------
// BlenderChartのイベント管理クラス
//-----------------------------------------------

(function() {
	'use strict';

	/**
	 * BlenderChartのイベント管理クラス コンストラクタ
	 *
	 * @module BlenderChart
	 * @class BlenderChart.EventManager
	 * @extends [BlenderComponent]
	 * @constructor
	 * @param chart {BlenderChart} BlenderChartインスタンス。
	 */
	function EventManager(chart) {
		var me = this;
		me.chart = chart;

		// コンポーネントの初期化を実行
		BlenderComponent.call(me, me.tagId);
	};

	// Extends
	EventManager.inherit(BlenderComponent);
	BlenderChart.EventManager = EventManager;

	/**
	 * イベントハンドラを設定する。
	 * 設定したハンドラは BlenderChartのobserversオプションと同期される。
	 *
	 * @method attachEvent
	 * @param type {string} イベント種別(例："valueChanged")
	 * @param func {function} イベントハンドラ
	 */
	EventManager.prototype.attachEvent = function(type, func) {
		var me = this;
		initHandlers(me);
		BlenderComponent.prototype.attachEvent.call(me, type, func);
	};

	/**
	 * イベントを通知する。
	 *
	 * @method _notifyEvent
	 * @param e 通知するイベント
	 */
	EventManager.prototype._notifyEvent = function(event) {
		var me = this;
		initHandlers(me);

		var chart = me.chart;

		// Chartが描画のバッファリングを実施していない場合、
		// バッファリングを開始する。
		var startBuffered = !chart._bufferedRender;

		if (startBuffered) {
			chart._bufferedRender = true;
			chart._bufferedRequest = null;
		}

		// イベントの通知
		BlenderComponent.prototype._notifyEvent.call(me, event);

		if (startBuffered) {
			// 描画要求
			var bufferedRequest = chart._bufferedRequest;
			if (bufferedRequest) {
				chart.render(bufferedRequest);
			}

			// 描画のバッファリング設定を解除
			chart._bufferedRender = false;
			chart._bufferedRequest = null;
		}
	};

	/**
	 * ハンドラオブジェクトを初期化する。
	 *
	 * @private
	 * @params eventManager {object} BlenderChartのイベント管理のハンドラオブジェクト
	 */
	function initHandlers(eventManager) {
		var handlers = eventManager.handlers;
		var chart = eventManager.chart;

		// observersオプションが存在しない場合は初期化。
		if (!chart.options.observers) {
			chart.options.observers = {};
		}

		if (chart.options.observers !== handlers) {
			// Chartのオプションと連動させる。
			Object.defineProperty(eventManager, 'handlers', createHandlersDescriptor(chart));
		}
	};

	/**
	 * ディスクリプタを生成する。
	 *
	 * @private
	 * @param chart {BlenderChart} BlenderChartインスタンス
	 * @return {object} handlersのディスクリプタ
	 */
	function createHandlersDescriptor(chart) {
		return {

			get: function() {
				return chart.options.observers;
			},

			set: function(value) {
				chart.options.observers = value;
			}

		};
	};

})();

//-----------------------------------------------
// BlenderChart Canvasの背景色の設定
//-----------------------------------------------

(function() {
	'use strict';

	Chart.plugins.register({

		id: 'blenderbackgroundcolor',

		beforeDraw: function(chart) {
			var backgroundColor = chart.options.backgroundColor;

			if (backgroundColor) {
				var ctx = chart.ctx;

				ctx.save();
				ctx.fillStyle = backgroundColor;
				ctx.fillRect(0, 0, chart.width, chart.height);
				ctx.restore();
			}
		}

	});

})();

/**
 * CSSクラス: グラフを表示するDIV領域
 *
 * @static
 * @final
 * @property {string} CSS_CLASS_CONTAINER_DIV CSS グラフを表示するDIV領域
 */
BlenderChart.CSS_CLASS_CONTAINER_DIV = 'blender-chart-container';

/**
 * CSSクラス: グラフ上に重なるDIV領域
 *
 * @static
 * @final
 * @property {string} CSS_CLASS_CONTAINER_DIV CSS グラフ上に重なるDIV領域
 */
BlenderChart.CSS_CLASS_OVERLAP_AREA = 'blender-chart-overlap-area';

/**
 * Chartをアニメーションせずに再描画する設定
 * update、render関数の引数として使用します。
 *
 * @static
 * @final
 * @property {object} UPDATE_CONFIG_IMMEDIATELY 即時再描画
 */
BlenderChart.UPDATE_CONFIG_IMMEDIATELY = Object.freeze({
	duration: 0,
	lazy: false
});

/**
 * ## BlenderChart
 * チャートコンポーネント
 *
 * @class BlenderChart
 * @extends [Chart]
 * @module BlenderChart
 * @constructor
 * @param id {string} グラフを表示するdiv要素のid
 * @param config {object} 初期表示設定
 */
function BlenderChart(id, config) {
	'use strict';

	var me = this;

	// DIV要素の初期化
	me._initChartContainer(id);

	// グラフを描画するcanvasを生成
	var $canvas = me._createChartCanvas(id);

	// グラフの上を覆うDIV要素を初期化
	me._createOverlapArea(id);

	// グラフの上を覆うDIV領域の表示抑止フラグ。
	me._suppressShowOverlapArea = false;

	// オブジェクトマネージャに登録
	BlenderObjectManager.putObject(id, me, 'chart');
	// イベントマネージャーの初期化
	me.eventManager = new BlenderChart.EventManager(me);

	// グラフの初期化
	Chart.call(me, $canvas, config);
};

// Extends
BlenderChart.inherit(Chart);

/**
 * グラフを表示するDIV要素の初期化を行う。
 *
 * @method _initContainer
 * @private
 * @param id {string} グラフを表示するdiv要素のid
 */
BlenderChart.prototype._initChartContainer = function(id) {
	'use strict';

	var me = this;

	// 引数のidを持つDIV要素を取得する。
	var $targetObj = $('#' + id);

	// 引数のIDの入力チェック
	if ($targetObj.prop('tagName') !== 'DIV') {
		throw new Error('引数のIDが不正です。[' + id + ']');
	}

	// DIV要素をChart表示用に設定する。
	$targetObj.empty();
	$targetObj.addClass(BlenderChart.CSS_CLASS_CONTAINER_DIV);

	// DIV要素の情報を保持する。
	me.tagId = id;
	me.$targetObj = $targetObj;
};

/**
 * グラフを描画するCanvas要素の生成を行う。
 *
 * @method _createChartCanvas
 * @private
 * @param idPrefix {string} Canvasに設定するidの接頭辞
 */
BlenderChart.prototype._createChartCanvas = function(idPrefix) {
	'use strict';

	var me = this;

	// Canvas要素のID
	var canvasId = idPrefix + '-canvas';
	// 親DIV要素
	var $targetObj = me.$targetObj;

	// 親DIV要素の幅と高さ
	var width = $targetObj.width();
	var height = $targetObj.height();

	// グラフを描画するcanvasを生成。
	return $('<canvas/>')
			.attr({
				id: canvasId,
				width: width,
				height: height
			})
			.css({
				width: width,
				height: height
			})
			.appendTo($targetObj);
};

/**
 * グラフの上を覆うDIV要素を生成する。
 *
 * @method _initOverlapArea
 * @private
 * @param idPrefix {string} 生成するDIV要素に設定するidの接頭辞
 */
BlenderChart.prototype._createOverlapArea = function(idPrefix) {
	'use strict';

	var me = this;

	return (me.$overlapArea = $('<div />')
			.attr("id", (idPrefix + '-overlap'))
			.addClass(BlenderChart.CSS_CLASS_OVERLAP_AREA)
			.appendTo(me.$targetObj));
};

/**
 * BlenderChartの更新処理
 *
 * @method update
 * @param config {number|object} 再描画のアニメーションの時間（ミリ秒単位）/ 再描画設定オブジェクト
 */
BlenderChart.prototype.update = function(config) {
	'use strict';

	var me = this;
	me.$overlapArea.css('display', 'none');

	Chart.prototype.update.apply(me, arguments);
};

/**
 * BlenderChartのフレーム毎の描画処理
 *
 * @method draw
 * @param easingValue {number} 現在のアニメーション値（0.0～1.0）
 * @param stepDecimal {number} アニメーションの進行度（現在のフレーム番号/総フレーム数）
 * @param currentStep {number} 現在のアニメーションフレーム番号
 */
BlenderChart.prototype.draw = function(easingValue, stepDecimal, currentStep) {
	'use strict';

	var me = this;
	Chart.prototype.draw.apply(me, arguments);

	if (Chart.helpers.isNullOrUndef(easingValue) || stepDecimal === 1) {
		// アニメーションなし、または最後のフレーム
		if (!me._suppressShowOverlapArea) {
			me.showOverlapArea();
		}
	}
};

/**
 * BlenderChartの破棄処理。
 * @method destroy
 */
BlenderChart.prototype.destroy = function() {
	'use strict';

	var me = this;

	Chart.prototype.destroy.call(me);

	// 追加したクラスを除去
	me.$targetObj.removeClass(BlenderChart.CSS_CLASS_CONTAINER_DIV);

	// 初期化時に生成した要素を除去
	me.$targetObj.empty();
	delete me.$overlapArea;
};

/**
 * グラフの上を覆うDIV領域の表示処理を行います。
 * @method showOverlapArea
 */
BlenderChart.prototype.showOverlapArea = function() {
	'use strict';

	var me = this;

	// 表示抑止を解除
	me._suppressShowOverlapArea = false;

	// 各プラグインへの表示処理開始通知
	if (Chart.plugins.notify(me, 'beforeOverlapAreaShow') === false) {
		return;
	}

	me.$overlapArea.css('display', '');

	// 各プラグインへの表示処理終了通知
	Chart.plugins.notify(me, 'afterOverlapAreaShow')
};

/**
 * グラフの上を覆うDIV領域を非表示にし、updateによる再表示を抑止します。
 * @method hideOverlapArea
 * @param suppressShow {boolean} true: 再表示を抑止する（既定の動作）／false：再表示を抑止しない
 */
BlenderChart.prototype.hideOverlapArea = function(suppressShow) {
	this._suppressShowOverlapArea = (suppressShow !== false);
	this.$overlapArea.css('display', 'none');
};

/**
 * 表示データのJSONをパースし、グラフに設定する。
 * @method parseDataJson
 * @param json {object} グラフの表示データを含むJSON
 */
BlenderChart.prototype.parseDataJson = function(json) {
	'use strict';

	var jsonDatasets = (json && json.datasets) || [];
	var jsonAxisLabels = json && json.axisLabels;

	var me = this;
	var chartData = me.data;

	// 表示データの更新
	chartData.datasets = jsonDatasets;

	// 軸ラベルの更新
	if (jsonAxisLabels) {
		var axisLabels, scaleId, labels;

		for (var i = 0, ilen = jsonAxisLabels.length; i < ilen; i++) {
			axisLabels = jsonAxisLabels[i];
			scaleId = axisLabels.id;
			labels = axisLabels.labels;

			if (scaleId === 'globalLabels') {
				chartData.labels = labels;
			} else {
				var scales = me.scales[scaleId];

				if (scales) {
					scales.options.labels = labels;
				}
			}
		}
	}

	// カスタム変更処理を行う。
	me._parseDataJsonCustom(json);

	// 再描画
	me.update(BlenderChart.UPDATE_CONFIG_IMMEDIATELY);
};

/**
 * 表示データのJSONをパースし、グラフに設定する処理した後のカスタム処理。
 * @method _parseDataJsonCustom
 * @param json {object} グラフの表示データを含むJSON
 */
BlenderChart.prototype._parseDataJsonCustom = Chart.helpers.noop;

/**
 * 全ての軸のIDを取得する。
 *
 * @method getScaleIds
 * @return 軸IDを格納した配列
 */
BlenderChart.prototype.getScaleIds = function() {
	return this.scales ? Object.keys(this.scales) : [];
};

/*
Copyright MITSUBISHI Elec.
*/